import { FC } from 'react';
import { useMediaQuery } from '@mui/material';
import { Charts } from '../../../../../../stories/molecules/charts/Charts';
import { muiTheme } from '../../../../../../theme';
import { ChartContainer } from './StockAccuracyModal.styles';

export type AccuracyChartProps = {
  chartSeries: ApexAxisChartSeries;
  dateRanges: string[];
};

export const AccuracyChart: FC<AccuracyChartProps> = ({ chartSeries, dateRanges }) => {
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('tabletPortrait'));

  return (
    <ChartContainer data-testid="stock-accuracy-chart-container">
      <Charts
        chartType="area"
        xAxisCategories={dateRanges}
        chartSeries={chartSeries}
        dataLabel={{
          enabled: !isMobile,
          style: {
            fontSize: '12px',
            fontWeight: '100',
            colors: [muiTheme.color.primary],
          },
          formatter: function (value: number) {
            if (!value) return '';
            return value.toFixed(2) + '%';
          },
        }}
      />
    </ChartContainer>
  );
};
